import React from 'react';
import { addDecimalPoints } from "../../../../../js/shared/utils";

const MyPassengersAverage = ({average} = props) => {
	return (
		<div
			className="my-passengers-average">
			<div>
				<div>
					Média
				</div>
				<div>
					<strong>
						{addDecimalPoints(average || 0)}
					</strong>
				</div>
			</div>
			<i data-tooltip="Esta é a média de milhas por passageiro desta venda. Clique na seta ao lado para ver os detalhes."
			   data-flow="left" className='tooltip gray'>
				?
			</i>
		</div>
	);
};

export default MyPassengersAverage;